import httpRequest from 'httpRequest'
import {
    ClosePaymentDeviceContract,
    CloseTerminalExceptionContract,
    DefaultDeviceContract,
    PosCloseTerminalWithPinContract,
    PosOpenTerminalContract,
    PosTerminalCloseContract,
    PosTerminalContract,
    PosTerminalMenuSlimContract,
    PosTerminalStatus,
    PosTerminalUpdateContract,
} from 'models'
import { CloseTerminalCashReportContract } from 'models/CloseTerminalCashReportContract'

const POS_TERMINAL_PREFIX = '/location/pos-terminals'

const posTerminalService = {
    getAllPosTerminals() {
        return httpRequest.get<PosTerminalContract[]>(POS_TERMINAL_PREFIX)
    },
    getPosTerminal(terminalId: string) {
        return httpRequest.get<PosTerminalUpdateContract>(
            `${POS_TERMINAL_PREFIX}/${terminalId}`,
        )
    },
    validationClosingPosTerminal(terminalId: string) {
        return httpRequest.get<CloseTerminalExceptionContract>(
            `${POS_TERMINAL_PREFIX}/${terminalId}/closing-validation`,
        )
    },
    updatePosTerminal(terminalId: string, payload: PosTerminalUpdateContract) {
        return httpRequest.put(`${POS_TERMINAL_PREFIX}/${terminalId}`, payload)
    },
    createPosTerminal(payload: PosTerminalUpdateContract) {
        return httpRequest.post(`${POS_TERMINAL_PREFIX}`, payload)
    },
    deletePosTerminals(terminalIds: string[]) {
        return httpRequest.delete(POS_TERMINAL_PREFIX, {
            params: { terminalIds },
        })
    },
    getCurrentTerminalMenu() {
        return httpRequest.get<PosTerminalMenuSlimContract>(
            `${POS_TERMINAL_PREFIX}/current/menus`,
        )
    },
    getCurrentPosTerminalInfo() {
        return httpRequest.get<PosTerminalContract>(
            `${POS_TERMINAL_PREFIX}/current`,
        )
    },
    getCurrentPosTerminalStatus() {
        return httpRequest.get<PosTerminalStatus>(
            `${POS_TERMINAL_PREFIX}/current/status`,
        )
    },
    getCurrentPostTerminalDevice() {
        return httpRequest.get<DefaultDeviceContract>(
            `${POS_TERMINAL_PREFIX}/current/default-device`,
        )
    },
    updateCurrentPosTerminalPrinter(payload: PosTerminalUpdateContract) {
        return httpRequest.put(
            `${POS_TERMINAL_PREFIX}/current/printer`,
            payload,
        )
    },
    updateCurrentPosTerminalCustomerFacingDisplay(
        payload: PosTerminalUpdateContract,
    ) {
        return httpRequest.put(
            `${POS_TERMINAL_PREFIX}/current/customer-facing-display`,
            payload,
        )
    },
    updateCurrentPosTerminalPaymentDevice(payload: PosTerminalUpdateContract) {
        return httpRequest.put(
            `${POS_TERMINAL_PREFIX}/current/payment-device`,
            payload,
        )
    },
    closePosTerminal(payload: PosCloseTerminalWithPinContract) {
        return httpRequest.post(
            `${POS_TERMINAL_PREFIX}/current/close-terminal`,
            payload,
        )
    },
    openPosTerminal(payload: PosOpenTerminalContract) {
        return httpRequest.post(
            `${POS_TERMINAL_PREFIX}/current/open-terminal`,
            JSON.stringify(payload),
        )
    },
    closePosCashTerminal(payload: PosCloseTerminalWithPinContract) {
        return httpRequest.post<CloseTerminalCashReportContract>(
            `${POS_TERMINAL_PREFIX}/current/close-cash-terminal`,
            payload,
        )
    },
    openPosCashTerminal(payload: PosOpenTerminalContract) {
        return httpRequest.post(
            `${POS_TERMINAL_PREFIX}/current/open-cash-terminal`,
            JSON.stringify(payload),
        )
    },
    closeAllTerminal: (terminals: PosTerminalCloseContract[]) =>
        httpRequest.post<ClosePaymentDeviceContract[]>(
            `${POS_TERMINAL_PREFIX}/close-terminals`,
            terminals,
        ),
}

export default posTerminalService
